import { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from '@/components/Layout';
import { useLanguage } from '@/context/LanguageContext';
import { FileText, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Mentions = () => {
  const { t, language } = useLanguage();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const response = await axios.get(`${API}/pages/mentions`);
        setPage(response.data);
      } catch (error) {
        console.error('Error fetching page:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchPage();
  }, []);

  const title = page ? (language === 'fr' ? page.title_fr : (page.title_de || page.title_fr)) : t('Mentions légales', 'Rechtliche Hinweise');
  const content = page ? (language === 'fr' ? page.content_fr : (page.content_de || page.content_fr)) : '';

  return (
    <Layout>
      <section className="py-20 md:py-32 bg-slate-50">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <div className="flex items-center gap-3 mb-8">
            <FileText className="w-8 h-8 text-blue-600" />
            <h1 className="text-3xl md:text-4xl font-bold text-slate-900 font-outfit" data-testid="mentions-title">
              {title}
            </h1>
          </div>

          {loading ? (
            <div className="flex justify-center py-12">
              <Loader2 className="w-8 h-8 animate-spin text-blue-600" />
            </div>
          ) : (
            <div className="bg-white rounded-2xl border border-slate-200 p-8 md:p-12">
              <div className="prose prose-slate max-w-none" data-testid="mentions-content">
                {content ? (
                  content.split('\n').map((paragraph, index) => (
                    paragraph.trim() && (
                      <p key={index} className="text-slate-700 leading-relaxed mb-4">
                        {paragraph}
                      </p>
                    )
                  ))
                ) : (
                  <>
                    <h2 className="text-xl font-bold text-slate-900 mt-6 mb-4 font-outfit">
                      {t('Responsable de la publication', 'Verantwortlich für die Veröffentlichung')}
                    </h2>
                    <p className="text-slate-700">Josias Djotchou</p>
                    
                    <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4 font-outfit">Contact</h2>
                    <p className="text-slate-700">
                      {t('Via le formulaire de contact du site', 'Über das Kontaktformular der Website')}
                    </p>
                    
                    <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4 font-outfit">
                      {t('Nature du site', 'Art der Website')}
                    </h2>
                    <p className="text-slate-700">
                      {t('Ce site est un blog personnel à but informatif.', 'Diese Website ist ein persönlicher Blog zu Informationszwecken.')}
                    </p>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
};

export default Mentions;
